import { render, staticRenderFns } from "./RightsNo1.vue?vue&type=template&id=f5d7e332"
import script from "./RightsNo1.vue?vue&type=script&lang=js"
export * from "./RightsNo1.vue?vue&type=script&lang=js"
import style0 from "./RightsNo1.vue?vue&type=style&index=0&id=f5d7e332&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports